import React from 'react';

const PdpSharedFrameIncludedLazyComponent = React.lazy(() =>
    import(/* webpackChunkName: "PdpSharedFrameIncluded" */ './PdpSharedFrameIncluded')
);

export const PdpSharedFrameIncludedLazy = props => (
    <React.Suspense fallback="">
        <PdpSharedFrameIncludedLazyComponent {...props} />
    </React.Suspense>
);
